export function useClickTarget(_ref) {
  var id = _ref.id,
      isShowing = _ref.isShowing,
      hide = _ref.hide,
      show = _ref.show;

  function toggle() {
    if (isShowing) {
      hide();
      return;
    }

    show();
  }

  return {
    'aria-haspopup': 'dialog',
    'aria-expanded': isShowing,
    'aria-controls': id,
    tabIndex: 0,
    // Since we no longer rely on native click events, we need
    // to emulate click behavior via keyboard.
    onKeyPress: function onKeyPress(e) {
      if (e.key === 'Enter') {
        toggle();
      }
    },
    // We no trigger popovers to appear onMouseDown
    onMouseDown: toggle
  };
}